import { useMemo } from "react";
import { getSelectedAduOptionCodes } from "src/components/organisms/FloorPlan";
import { ImageDisplay } from "src/pages/configurator/components";
import { getAduImages } from "src/pages/configurator/Configurator.utils";
import { Css } from "~generated/css";
import { SummaryPrintConfiguration_CheckoutConfigFragment } from "../SummaryPrint.page.generated";
import { PDFPage } from "./PDFPage";
import { PrintHeader } from "./PrintHeader";

type AduReportProps = {
  data: SummaryPrintConfiguration_CheckoutConfigFragment;
  shouldDisplayPricing: boolean;
};

export function AduReport({ data }: AduReportProps) {
  const { name, customerEmail, createdAt, reservedAt, expiresAt, status, optionGroups } = data;
  const selectedOptionCodes = useMemo(
    () => getSelectedAduOptionCodes(optionGroups, optionGroups.flatMap((og) => og.selectedOption?.id).compact()),
    [optionGroups],
  );

  const aduImages = useMemo(() => getAduImages(data), [data]);

  return (
    <>
      {aduImages.map((image) => {
        const imageId = image.kind === "insideMaps" ? image.roomLocationId : image.id;
        return (
          <PDFPage key={imageId}>
            <div css={Css.relative.h100.w100.bgWhite.$}>
              <div css={Css.df.ma.fdc.gap2.p1.pb4.asc.maxContainer.$}>
                <PrintHeader
                  status={status}
                  expiredAt={expiresAt}
                  createdAt={createdAt}
                  reservedAt={reservedAt}
                  configurationName={name}
                  customerEmail={customerEmail}
                />
                <div css={Css.t16.gray900.fw600.$}>{image.previewCardName}</div>
                {image.kind === "image" && (
                  <img src={image.imageUrl ?? ""} css={Css.w100.ha.$} alt={image.previewCardName} />
                )}
                {image.kind === "floorPlan" && (
                  <div css={Css.df.fdc.mhPx(700).w100.ma.$}>
                    <ImageDisplay images={[image]} selectedOptionCodes={selectedOptionCodes} />
                  </div>
                )}
              </div>
              {/* Disclaimer */}
              <div id="disclaimer" css={Css.t12.pt2.tac.gray700.$}>
                All images, design layouts, and renderings are intended for illustrative purposes only and may be
                subject to change. Layout and details will vary depending on selected floor plan.
              </div>
            </div>
          </PDFPage>
        );
      })}
    </>
  );
}
